riot.tag2('comment-feedback-modal-success', '<div class="messaging-modal-body"> <div class="messaging-modal-body-icon"> <span class="check--before"></span> </div> <h2 class="messaging-modal-title text-center">Din kommentar är sparad</h2> <button class="secondary-action" onclick="{onClose}">Stäng</button> </div>', '', '', function(opts) {
        this.onClose = function(evt) {
            this.bus.trigger('ui:comment-feedback-modal-success:on-close');
        }.bind(this);
});



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-success.riot.html